import styled from 'styled-components';
import { layout, remCalc } from 'src/components/base';

export const Header = styled.div`
  display: flex;
  margin-bottom: ${layout.measurements.spacing200};
`;

export const Title = styled.h1`
  font-size: ${remCalc(36)};
  font-weight: normal;
  margin-bottom: ${layout.measurements.spacing050};
`;
